// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"7e134b10","152":"6cf73902","187":"9fcc20f9","404":"d4cec54f","730":"789fc031"}[chunkId] + ".css";
};